/**
 * InvoiceDetailsModal — Detalhes completos de um invoice (tela de cobrança).
 * Campos da linha sem truncar + bloco de detalhes + data (JSONB).
 */
import { FaTimes, FaFileInvoiceDollar } from 'react-icons/fa';
import InvoiceDetailsContent from './InvoiceDetailsContent';

export { formatAutomations } from './InvoiceDetailsContent';

interface Props {
    invoice: any;
    onClose: () => void;
}

const InvoiceDetailsModal: React.FC<Props> = ({ invoice, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
        <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl p-6 max-w-2xl w-full mx-4 max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-2" title={invoice.invoiceId}>
                    <FaFileInvoiceDollar className="text-blue-500" />
                    Fatura {invoice.invoiceId ? invoice.invoiceId.slice(0, 8) : ''}
                </h2>
                <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                    <FaTimes size={20} />
                </button>
            </div>
            <InvoiceDetailsContent invoice={invoice} />
        </div>
    </div>
);

export default InvoiceDetailsModal;
